<aside [attr.aria-label]="'side_menu_label' | transloco" [class]="asideClass()">
  @if (variant() === 'admin') {
    <div
      data-admin-bar
      class="flex h-6xl shrink-0 items-center justify-center gap-sm bg-destructive-700 text-white">
      <lib-side-menu-icon
        name="user-octagon"
        iconClass="size-5 text-white do-not-transform" />
      @if (!collapsed()) {
        <span class="text-xs font-semibold uppercase">{{
          'admin_dashboard_label' | transloco
        }}</span>
      }
    </div>
  }

  <div
    data-side-menu-header
    [class]="
      'flex shrink-0 px-lg pt-lg ' +
      (collapsed()
        ? 'flex-col items-center gap-sm border-b border-neutral-200 pb-sm'
        : 'items-center justify-between gap-sm pb-lg')
    ">
    @if (collapsed()) {
      <lib-avatar
        [fullName]="workspaceName()"
        [img]="workspaceLogo()"
        imgClass="size-4xl rounded-md" />
    } @else {
      <div
        class="min-w-0 flex-1 overflow-hidden [&_img]:h-auto [&_img]:max-h-8 [&_img]:max-w-full [&_svg]:h-auto [&_svg]:max-h-8 [&_svg]:max-w-full"
        data-logo>
        <lib-navbar-banner-logo [selectedWorkspace]="workspace()" />
      </div>
    }
    <div
      [class]="
        collapsed()
          ? 'flex flex-col items-center gap-sm'
          : 'flex items-center gap-sm'
      ">
      <lib-notification-bell placement="side" />
      <button
        type="button"
        id="side_menu_collapse_button"
        [attr.aria-label]="
          (collapsed() ? 'side_menu_expand_label' : 'side_menu_collapse_label')
            | transloco
        "
        [attr.aria-expanded]="!collapsed()"
        class="flex size-4xl items-center justify-center rounded-md text-neutral-500 hover:bg-neutral-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
        (click)="toggleCollapsed()">
        <span [class]="collapsed() ? 'inline-flex rotate-180' : 'inline-flex'"
          ><lib-side-menu-icon name="sidebar" iconClass="size-5"
        /></span>
      </button>
    </div>
  </div>

  <nav
    [attr.aria-label]="'side_menu_label' | transloco"
    [class]="
      'min-h-0 flex-1 overflow-y-auto px-lg pt-sm' +
      (collapsed() ? ' pt-sm' : '')
    ">
    @for (block of blocks(); track $index) {
      @if (block.rule) {
        <hr
          [class]="
            block.groupRule
              ? '-mx-lg my-[calc(var(--spacing-md)*0.625)] border-neutral-200'
              : '-mx-lg my-sm border-neutral-200'
          " />
      }
      <ul
        [class]="
          block.spaced ? 'mt-md flex flex-col gap-x-sm' : 'flex flex-col gap-sm'
        ">
        @for (row of block.rows; track row.key; let i = $index) {
          @if (i > 0 && row.group && block.rows[i - 1].group) {
            <li aria-hidden="true">
              <hr
                class="-mx-lg my-[calc(var(--spacing-md)*0.625)] border-neutral-200" />
            </li>
          }
          <li>
            @if (row.group) {
              <lib-side-menu-group
                [group]="row.item"
                [open]="row.open"
                [collapsed]="collapsed()"
                (toggle)="toggleGroup(row.key)" />
            } @else {
              <lib-side-menu-item [item]="row.item" [collapsed]="collapsed()" />
            }
          </li>
        }
      </ul>
    }
  </nav>

  <div
    data-side-menu-footer
    class="shrink-0 border border-neutral-200 px-sm py-x-sm m-md rounded-2xl">
    <lib-side-menu-profile [collapsed]="collapsed()" />
  </div>
</aside>
